/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable  @typescript-eslint/no-var-requires */
const TargetClient = require('@adobe/target-nodejs-sdk');

const TARGET_CONFIG = {
  client: process.env['TARGET_CLIENT'] || 'TARGET_CLIENT',
  organizationId: process.env['TARGET_ORG_ID'] || 'TARGET_ORG_ID',
};

const targetClient = TargetClient.create(TARGET_CONFIG);

const mergeTargetRequestContext = (req: any, requestContext?: any) => {
  if (!requestContext || typeof requestContext !== 'object') {
    return req;
  }

  return {
    ...req,
    context: {
      ...(req?.context || {}),
      ...requestContext,
      geo: {
        ...(req?.context?.geo || {}),
        ...(requestContext?.geo || {}),
      },
    },
  };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function getTargetOffers(req: any, sessionId: string, requestContext?: any) {
  try {
    const mergedRequest = mergeTargetRequestContext(req, requestContext);
    const response = await targetClient.getOffers({
      request: mergedRequest,
      sessionId,
    });
    return response;
  } catch (error: any) {
    throw new Error(`Error fetching target offers: ${error.message}`);
  }
}
